var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4452_14509)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 16.8,
    stroke: "url(#paint0_linear_4452_14509)",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6892 25.6932C26.6418 25.6932 26.5962 25.6744 26.5627 25.641C26.5291 25.6075 26.5102 25.5622 26.5102 25.5148V10.7175C26.5111 10.4859 26.4546 10.2577 26.3458 10.053C26.237 9.84834 26.0792 9.67355 25.8865 9.5441C25.6938 9.41466 25.472 9.33454 25.2408 9.31086C25.0096 9.28717 24.7761 9.32064 24.561 9.4083C22.6231 10.204 20.7955 11.2441 19.1231 12.503C15.7221 15.0661 14.3295 18.2785 14.3295 21.3411C14.3295 24.4036 16.3683 25.6361 18.0222 25.6361C19.6762 25.6361 21.7471 24.1931 21.7471 21.3411C21.7471 18.489 21.0043 17.3224 20.0359 15.6565C20.9349 15.1787 21.9001 14.8367 22.8999 14.6416C22.9697 14.6276 23.0417 14.6292 23.1107 14.6463C23.1798 14.6634 23.2442 14.6955 23.2993 14.7404C23.3545 14.7852 23.3989 14.8417 23.4295 14.9058C23.4601 14.9698 23.4761 15.0398 23.4763 15.1107V25.6932C23.4763 26.013 23.6037 26.3197 23.8307 26.5458C24.0576 26.7719 24.3654 26.899 24.6863 26.899H27.7077V25.6932H26.6892ZM18.024 24.994C17.308 24.994 16.1446 24.0487 16.1446 21.5676C16.1446 19.0865 17.6571 17.4259 18.0401 17.1673C18.3659 17.3974 19.9357 19.0562 19.9357 21.5658C19.9357 24.0754 18.74 24.994 18.024 24.994ZM15.0026 15.1589C14.4085 14.8988 13.7844 14.7131 13.1446 14.6059C13.0764 14.5959 13.0068 14.6007 12.9406 14.6199C12.8745 14.6392 12.8133 14.6725 12.7612 14.7176C12.7092 14.7627 12.6676 14.8185 12.6392 14.8811C12.6108 14.9437 12.5964 15.0117 12.5969 15.0804V25.6932C12.5969 26.013 12.4694 26.3197 12.2425 26.5458C12.0155 26.7719 11.7078 26.899 11.3868 26.899H8.29199V25.6932H9.39103C9.4385 25.6932 9.48403 25.6744 9.5176 25.641C9.55117 25.6075 9.57003 25.5622 9.57003 25.5148V10.7353C9.57017 10.5037 9.62756 10.2756 9.73713 10.0713C9.8467 9.86696 10.0051 9.69266 10.1983 9.56379C10.3915 9.43491 10.6135 9.35543 10.8449 9.33236C11.0762 9.30928 11.3097 9.34333 11.5247 9.43149C13.542 10.2429 15.4356 11.3314 17.1505 12.6653C16.3266 13.3977 15.6043 14.2363 15.0026 15.1589Z",
    fill: "url(#paint1_linear_4452_14509)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4452_14509",
    x1: 32.0792,
    y1: 3.38614,
    x2: 4.81188,
    y2: 34.0396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16D6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BC6DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4452_14509",
    x1: 8.29199,
    y1: 27.9102,
    x2: 28.451,
    y2: 9.23256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18D995"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4452_14509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b3bd919f3d178055bbc6563d7d4499f7.svg";
export { ForwardRef as ReactComponent };